<template>
  <div class="index">
    <div id="top" style="display: flex;justify-content: center;align-items: center;">
      <div style="min-width: 800px;display: flex;flex-direction: column;align-items: flex-end;margin-top: -60px;">
        <span
            style="font-size:60px;color: #CF1C1D;font-weight: bold;float: right;font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;">中共利津县委组织部“12380”举报网站</span>
        <!--        <br/>-->
        <span style="font-size:30px;color: #CF1C1D;float: right;">http://www.lj12380.gov.cn</span>
      </div>

      &nbsp;
    </div>

    <div id="header">
      <div id="header_box">
        <ul id="navigation">
          <li id="li1" ref="li1" class="selected" style="cursor: pointer;" v-on:mouseout="removeActive(1)"
              v-on:mouseover="changeActive(1)">
            <div id="tabs1" ref="tabs1" class="top_tab_style" @click="tabSwitch('tabs','page',1)"><img :src="imglogo1"/><span>首页</span>
            </div>
          </li>
          <li id="li4" ref="li4" style="cursor: pointer;" v-on:mouseout="removeActive(4)"
              v-on:mouseover="changeActive(4)">
            <div id="tabs4" ref="tabs4" class="top_tab_style" @click="tabSwitch('tabs','page',4)"><img :src="imglogo4"/><span>举报须知</span>
            </div>
          </li>

<!--          <li id="li3" ref="li3" style="cursor: pointer;" v-on:mouseout="removeActive(3)"
              v-on:mouseover="changeActive(3)">
            <div id="tabs3" ref="tabs3" class="top_tab_style" @click="tabSwitch('tabs','page',3)"><img :src="imglogo3"/><span>受理介绍</span>
            </div>
          </li>-->
          <!-- <li id="li4" ref="li4" v-on:mouseover="changeActive(4)" v-on:mouseout="removeActive(4)" style="cursor: pointer;">
            <div class="top_tab_style" id="tabs4" ref="tabs4" @click="tabSwitch('tabs','page',4)"><img :src="imglogo4" /><span>法规制度</span></div>
          </li> -->
<!--          <li id="li5" ref="li5" style="cursor: pointer;min-width: 180px;" v-on:mouseout="removeActive(5)"
              v-on:mouseover="changeActive(5)">
            <div id="tabs5" ref="tabs5" class="top_tab_style" @click="tabSwitch('tabs','page',5)"><img :src="imglogo5"/><span>市县区联系方式</span>
            </div>
          </li>-->
          <li id="li8" ref="li8" style="cursor: pointer;" v-on:mouseout="removeActive(8)"
              v-on:mouseover="changeActive(8)">
            <div id="tabs8" ref="tabs8" class="top_tab_style" @click="tabSwitch('tabs','page',8)"><img :src="imglogo8"/><span>其他举报方式</span>
            </div>
          </li>
          <li id="li6" ref="li6" style="cursor: pointer;" v-on:mouseout="removeActive(6)"
              v-on:mouseover="changeActive(6)">
            <div id="tabs6" ref="tabs6" class="top_tab_style" @click="tabSwitch('tabs','page',6)"><img :src="imglogo6"/><span>意见建议</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 首页 -->
    <div style="width:100%;background-size: 100% auto;margin-top: 80px;">
      <div :style="{
			minHeight: `${windowHeight - 510}px`
		}" class="mbmContent">

        <!-- 首页 -->
        <div v-show="isVisible1" id="page1" ref="page1" class="pageCss">
          <div id="reportTips">
            <div align="center">
              <div style="width: 460px;height: 30px;">
                <h1 style="display: flex;align-items: center;">
                  <div class="gradient-line"></div>
                  <span style="color: #BB1800;">首页</span>
                  <div class="gradient-line-right"></div>
                </h1>
              </div>
            </div>
            <div style="margin-right: 20px;margin-left: 20px;margin-top: 30px;">
              <div id="pageText" style="margin-top: 10px;width: 100%;margin:0 auto; height: 150px;">
                <p align="left"
                   style="font-size: 15pt;text-indent:2em;text-align:justify; text-justify:inter-ideograph;line-height: 40px;">欢迎进入中共利津县委组织部“12380”举报网站。本举报网站主要受理反映利津县各级领导班子和领导干部违反干部选拔任用工作政策法规选人用人，以及领导干部政治、思想、作风、廉洁自律等方面问题的举报。</p>
                <p align="left" style="font-size: 15pt;text-indent:2em;">感谢您对我们的信任和支持！</p>
                <!-- <div class="btndiv"><a onclick="tabSwitch('tabs','page',2)"><img height="40" src="/img/btn_jb.gif" width="200" /></a></div> -->
              </div>
            </div>
            <div class="dotted-line"></div>
            <!-- <div class="btndiv_ty" style="display: flex;align-items: center;">
              <input id="agree" name="agree" type="radio" value="false" v-model="isAgreeChecked" style="cursor: pointer;"/><span style="font-size: medium;">我同意以上条款</span>
            </div> -->
            <div class="btndiv" style="display: flex;justify-content: center;">
              <a style="cursor: pointer;" @click="showPopup(2)">
                <div
                    style="width: 200px;height: 40px; background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                  <span style="color: #fff;font-size: large;">举报个人</span></div>
              </a>&nbsp;
              <a style="cursor: pointer;" @click="showPopup(7)">
                <div
                    style="width: 200px;height: 40px; background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                  <span style="color: #fff;font-size: large;">举报单位</span></div>
              </a>
              <Popup ref="child" :content="popupContent" :visible="popupVisible" @close="closePopup"
                     @goForm="goReport"/>
            </div>
          </div>
          <div id="page1Width" style="margin-top: 10px;width: 100%;margin:0 auto; ">
            <div>
              <div id="lj" style="width: 100%;">
                <a href="http://dongyingdj.gov.cn/portal/site/index/site/19" target="_blank">
                  <div class="yc_info_left_dt" style="width: 100%;background-position:top center;display: flex;justify-content: center;"><img
                      :src="require('@/assets/topbanner_lj.png')" no-repeat style="width: 800px;height: 194px"/></div>
                </a>
              </div>

            </div>
          </div>
        </div>

        <!-- 举报个人 -->
        <div v-show="isVisible2" id="reportPersonal" ref="reportPersonal" class="pageCss">
          <form id="inputPsersonForm" action="" class="form-horizontal m-t" method="post">
            <input id="isPersonal" name="isPersonal" type="hidden" value="1"/>
            <div id="main">
              <!-- 举报人 -->
              <div
                  style="width:85%;margin-left: 7.5%;background: -moz-linear-gradient(top,rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);">
                <div align="center">
                  <div style="width: 520px;height: 30px;">
                    <h1 style="display: flex;align-items: center;">
                      <div class="gradient-line"></div>
                      <span style="color: #BB1800;">举报个人</span>
                      <div class="gradient-line-right"></div>
                    </h1>
                  </div>
                </div>
                <div style="display: flex;align-items: center; margin-top: 30px;line-height: 45px;">
                  <div class="vertical-rectangle"></div>
                  <span style="color: #BB1800;font-weight: bold;font-size: 16pt;">&nbsp;举报人信息</span>
                </div>
                <div style="">
                  <div class="panel-body">
                    <table class="form" style="width: 100%;">
                      <TBODY>
                      <tr>
                        <th class="formTitle" style="font-size: 13pt;font-family: Arial, Helvetica, sans-serif;">
                          所在地区:
                        </th>
                        <td class="formValue" colspan="3">
<!--                          <div>
                            <div style="width: 100%;float: left;">
                              &lt;!&ndash;														<v-select :options="options" v-model="psersonForm.area" :reduce="value => value.value" />&ndash;&gt;
                              <el-select v-model="psersonForm.area" clearable filterable placeholder="" size="medium" :popper-append-to-body="false"
                                         style="width: 100%;">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </div>-->
                          <input id="area" v-model="psersonForm.area" class="form-control" name="area"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 举报人姓名:</th>
                        <td class="formValue">
                          <input id="reportName" v-model="psersonForm.reportName" class="form-control" name="reportName"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style=""> 所在单位:</th>
                        <td class="formValue" colspan="3">
                          <input id="unitLocat" v-model="psersonForm.unitLocat" class="form-control" name="unitLocat"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 性别:</th>
                        <td class="formValue">
                          <!--												<select class="form-control" id="reportSex" name="reportSex" data-placeholder="请选择" v-model="psersonForm.reportSex" style="width: 100%">-->
                          <!--													<option value="">请选择</option>-->
                          <!--													<option value="男">男</option>-->
                          <!--													<option value="女">女</option>-->
                          <!--												</select>-->
                          <el-select v-model="psersonForm.reportSex" clearable placeholder="请选择" size="medium" :popper-append-to-body="false"
                                     style="width: 100%">
                            <el-option key="男" label="男" value="男"></el-option>
                            <el-option key="女" label="女" value="女"></el-option>
                          </el-select>
                        </td>

                      </tr>
                      <tr>
                        <th class="formTitle" style=""> 联系地址:</th>
                        <td class="formValue" colspan="3">
                          <input id="contactAddress" v-model="psersonForm.contactAddress" class="form-control"
                                 name="contactAddress" style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 职务:</th>
                        <td class="formValue">
                          <input id="reportJob" v-model="psersonForm.reportJob" class="form-control" name="reportJob"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>
                      <tr>

                        <th class="formTitle" style=""> 手机:</th>
                        <td class="formValue">
                          <input id="cellphone" v-model="psersonForm.cellphone" class="form-control" maxlength="11"
                                 name="cellphone" oninput="value=value.replace(/[^\d]/g,'')" style="width: 100%"
                                 type="text" value=""/>
                        </td>

                        <th class="formTitle" style=""> 身份证号:</th>
                        <td class="formValue">
                          <input id="idCard" v-model="psersonForm.idCard" class="form-control" maxlength="18"
                                 name="idCard" oninput="value=value.replace(/[^\d|xX]/g,'')" style="width: 100%"
                                 type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 固话:</th>
                        <td class="formValue">
                          <input id="telephone" v-model="psersonForm.telephone" class="form-control" maxlength="13"
                                 name="telephone" oninput="value=value.replace(/[^\d{1,}\-\d{1,}|\d{1,}]/g,'')"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>

                      <tr>
                        <th class="formTitle" style=""> 邮政编码:</th>
                        <td class="formValue">
                          <input id="postcode" v-model="psersonForm.postcode" class="form-control" maxlength="6"
                                 name="postcode" oninput="value=value.replace(/[^\d]/g,'')" style="width: 100%"
                                 type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> E-mail:</th>
                        <td class="formValue">
                          <input id="email" v-model="psersonForm.email" class="form-control" maxlength="20" name="email"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="6" style="width: 100%">
                          <div style="display: flex;align-items: center;">
                            <div class="vertical-rectangle"></div>
                            <span style="color: #BB1800;font-weight: bold;font-size: 16pt;">&nbsp;被举报人信息</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>所在地区:</th>
                        <td class="formValue" colspan="3">
<!--                          <div>

                            <div style="width: 100%;">
                              &lt;!&ndash;													<v-select :options="options" v-model="psersonForm.areaed" :reduce="value => value.value" />&ndash;&gt;
                              <el-select v-model="psersonForm.areaed" clearable filterable placeholder="" size="medium" :popper-append-to-body="false"
                                         style="width: 100%;">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </div>-->

                          <input id="areaed" v-model="psersonForm.areaed" class="form-control" name="areaed"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>被举报人:</th>
                        <td class="formValue">
                          <input id="reportedName" v-model="psersonForm.reportedName" class="form-control "
                                 name="reportedName" style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>
                      <tr>

                        <th class="formTitle" style=""> 性别:</th>
                        <td class="formValue">

                          <!--											<select class="form-control" id="reportedSex" name="reportedSex" data-placeholder="请选择" v-model="psersonForm.reportedSex" style="width: 100%">-->
                          <!--												<option value="">请选择</option>-->
                          <!--												<option value="男">男</option>-->
                          <!--												<option value="女">女</option>-->
                          <!--											</select>-->
                          <el-select v-model="psersonForm.reportedSex" clearable placeholder="请选择" size="medium" :popper-append-to-body="false"
                                     style="width: 100%">
                            <el-option key="男" label="男" value="男"></el-option>
                            <el-option key="女" label="女" value="女"></el-option>
                          </el-select>
                        </td>

                        <th class="formTitle" style=""> 政治面貌:</th>
                        <td class="formValue">
                          <!--											<select class="form-control chosen-select" codeId="ZZMM01" data-placeholder="请选择" id="politicalOutlook" name="politicalOutlook" v-model="psersonForm.politicalOutlook" style="width: 100%" tabindex="2">-->
                          <!--												<option value="">请选择</option>-->
                          <!--												<option value="群众">群众</option>-->
                          <!--												<option value="中国共产党党员">中国共产党党员</option>-->
                          <!--												<option value="中国共产党预备党员">中国共产党预备党员</option>-->
                          <!--												<option value="中国共产主义青年团团员">中国共产主义青年团团员</option>-->
                          <!--												<option value="中国国民党革命委员会会员">中国国民党革命委员会会员</option>-->
                          <!--												<option value="中国民主同盟盟员">中国民主同盟盟员</option>-->
                          <!--												<option value="中国民主建国会会员">中国民主建国会会员</option>-->
                          <!--												<option value="中国民主促进会会员">中国民主促进会会员</option>-->
                          <!--												<option value="中国农工民主党党员">中国农工民主党党员</option>-->
                          <!--												<option value="中国致公党党员">中国致公党党员</option>-->
                          <!--												<option value="九三学社社员">九三学社社员</option>-->
                          <!--												<option value="台湾民主自治同盟盟员">台湾民主自治同盟盟员</option>-->
                          <!--												<option value="无党派民主人士">无党派民主人士</option>-->
                          <!--										  </select>-->
                          <el-select v-model="psersonForm.politicalOutlook" clearable placeholder="请选择" size="medium" :popper-append-to-body="false"
                                     style="width: 100%">
                            <el-option key="群众" label="群众" value="群众"></el-option>
                            <el-option key="中国共产党党员" label="中国共产党党员" value="中国共产党党员"></el-option>
                            <el-option key="中国共产党预备党员" label="中国共产党预备党员"
                                       value="中国共产党预备党员"></el-option>
                            <el-option key="中国共产主义青年团团员" label="中国共产主义青年团团员"
                                       value="中国共产主义青年团团员"></el-option>
                            <el-option key="中国国民党革命委员会会员" label="中国国民党革命委员会会员"
                                       value="中国国民党革命委员会会员"></el-option>
                            <el-option key="中国民主同盟盟员" label="中国民主同盟盟员"
                                       value="中国民主同盟盟员"></el-option>
                            <el-option key="中国民主建国会会员" label="中国民主建国会会员"
                                       value="中国民主建国会会员"></el-option>
                            <el-option key="中国民主促进会会员" label="中国民主促进会会员"
                                       value="中国民主促进会会员"></el-option>
                            <el-option key="中国农工民主党党员" label="中国农工民主党党员"
                                       value="中国农工民主党党员"></el-option>
                            <el-option key="中国致公党党员" label="中国致公党党员" value="中国致公党党员"></el-option>
                            <el-option key="九三学社社员" label="九三学社社员" value="九三学社社员"></el-option>
                            <el-option key="台湾民主自治同盟盟员" label="台湾民主自治同盟盟员"
                                       value="台湾民主自治同盟盟员"></el-option>
                            <el-option key="无党派民主人士" label="无党派民主人士" value="无党派民主人士"></el-option>
                          </el-select>
                        </td>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>级别:</th>
                        <td class="formValue">
                          <!--											<select class="form-control chosen-select" codeId="JB01" data-placeholder="请选择" id="reportedLevel" name="reportedLevel" v-model="psersonForm.reportedLevel" style="width: 100%" tabindex="2">-->
                          <!--												<option value="">请选择</option>-->
                          <!--												<option value="厅、局级">厅、局级</option>-->
                          <!--												<option value="副厅、副局级">副厅、副局级</option>-->
                          <!--												<option value="县、处级">县、处级</option>-->
                          <!--												<option value="副县、副处级">副县、副处级</option>-->
                          <!--												<option value="乡、科级">乡、科级</option>-->
                          <!--												<option value="副乡、副科级">副乡、副科级</option>-->
                          <!--												<option value="其他">其他</option>-->
                          <!--										  </select>-->
                          <el-select v-model="psersonForm.reportedLevel" clearable placeholder="请选择" size="medium" :popper-append-to-body="false"
                                     style="width: 100%">
                            <el-option key="厅、局级" label="厅、局级" value="厅、局级"></el-option>
                            <el-option key="副厅、副局级" label="副厅、副局级" value="副厅、副局级"></el-option>
                            <el-option key="县、处级" label="县、处级" value="县、处级"></el-option>
                            <el-option key="副县、副处级" label="副县、副处级" value="副县、副处级"></el-option>
                            <el-option key="乡、科级" label="乡、科级" value="乡、科级"></el-option>
                            <el-option key="副乡、副科级" label="副乡、副科级" value="副乡、副科级"></el-option>
                            <el-option key="其他" label="其他" value="其他"></el-option>
                          </el-select>
                        </td>
                      </tr>
                      <tr>

                        <th class="formTitle" style=""> 所在单位:</th>
                        <td class="formValue" colspan="3">
                          <input id="unitLocated" v-model="psersonForm.unitLocated" class="form-control"
                                 name="unitLocated" style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 所任职务:</th>
                        <td class="formValue">
                          <input id="reportedJob" v-model="psersonForm.reportedJob" class="form-control"
                                 name="reportedJob" style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>

                      <tr>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>主要问题:</th>
                        <td class="formValue" colspan="5">
                          <textarea id="mainProblems" v-model="psersonForm.mainProblems" class="form-control "
                                    name="mainProblems" rows="5"
                                    style="resize:none;height: 150px !important;width: 100%;" value=""></textarea>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style="">上传附件:</th>
                        <td class="formValue" colspan="5" style="border: 1px solid #ccc;border-radius: 3px;">
                          <el-upload
                              ref="upload"
                              :auto-upload="true"
                              :before-upload="beforeUpload"
                              :file-list="fileList"
                              :limit=1
                              :on-preview="handlePreview"
                              :on-remove="handleRemove"
                              :on-success="handleUploadSuccess"
                              accept=".zip"
                              action="/api/api/upload"
                              class="upload-demo">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传zip压缩文件，且不超过10MB</div>
                          </el-upload>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>验证码:</th>
                        <td class="formValue">
                          <input id="Txtidcode" v-model="code" class="form-control" name="Txtidcode"
                                 placeholder="请输入验证码" style="height: 28px; width: 95%;" type="text"/>
                        </td>
                        <td class="formTitle">
                          <div class="login-code" style="float: left;" @click="refreshCode()">
                            <!--验证码组件-->
                            <s-identify :identifyCode="identifyCode"></s-identify>
                          </div>
                          <!-- <a @click="refreshCode()" style="cursor: pointer;color: #1098EC;float: left;margin-top: 5px;">换个验证码？</a> -->
                        </td>
                        <td class="formValue">
                          <a style="cursor: pointer;color: #1098EC;float: left;margin-top: 5px;" @click="refreshCode()">换个验证码？</a>
                        </td>
                        <td class="formTitle"></td>
                        <td class="formValue"></td>
                      </tr>
                      </TBODY>
                    </table>
                  </div>
                </div>
              </div>


              <!-- <div style="width:85%;float:left;margin-bottom: 10px">
                <div style="margin-left: 137px">
                  <div style="float: left;margin-top: 5px;margin-left: 8px ;font-size: 13pt;font-family: Arial, Helvetica, sans-serif;">验证码：</div>
                  <div style="float: left;"><input class="form-control" id="Txtidcode" name="Txtidcode" v-model="code" placeholder="请输入验证码" type="text" style="height: 28px;" /></div>
                  <div class="login-code" style="float: left;" @click="refreshCode()">

                    <s-identify :identifyCode="identifyCode" ></s-identify>
                  </div>
                  <a @click="refreshCode()" style="cursor: pointer;color: #1098EC;float: left;margin-top: 5px;">换个验证码？</a>
                </div>
              </div> -->

              <div class="btndiv" style="display: flex; justify-content: center; align-items: center;">
                <a style="cursor: pointer;" @click="resetForm()">
                  <div
                      style="width: 200px;height: 40px; background-color: #C5C5C5;display: flex;justify-content: center;align-items: center;">
                    <span style="color: #fff;font-size: large;">重写</span></div>
                </a> &nbsp;
                <a style="cursor: pointer;" @click="commit()">
                  <div
                      style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                    <span style="color: #fff;font-size: large;">提交</span></div>
                </a>
              </div>
            </div>
          </form>
        </div>

        <!-- 举报单位 -->
        <div v-show="isVisible7" id="reportUnitLocat" ref="reportUnitLocat" class="pageCss">
          <form id="inputUnitLocatForm" action="" class="form-horizontal m-t" method="post">
            <input id="isUnitLocat" name="isUnitLocat" type="hidden" value="1"/>
            <div id="main">
              <!-- 举报人 -->
              <div
                  style="width:85%;margin-left: 7.5%;background: -moz-linear-gradient(top,rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);">
                <div align="center">
                  <div style="width: 520px;height: 30px;">
                    <h1 style="display: flex;align-items: center;">
                      <div class="gradient-line"></div>
                      <span style="color: #BB1800;">举报单位</span>
                      <div class="gradient-line-right"></div>
                    </h1>
                  </div>
                </div>

                <div style="display: flex;align-items: center;margin-top: 30px;line-height: 45px;">
                  <div class="vertical-rectangle"></div>
                  <span style="color: #BB1800;font-weight: bold;font-size: 16pt;">&nbsp;举报人信息</span>
                </div>
                <div style="">
                  <div class="panel-body">
                    <table class="form" style="width: 100%;">
                      <TBODY>
                      <tr>
                        <th class="formTitle" style="font-size: 13pt;font-family: Arial, Helvetica, sans-serif;">
                          所在地区:
                        </th>
                        <td class="formValue" colspan="3">
<!--                          <div>

                            <div style="width: 100%;float: left;">

                              &lt;!&ndash;														<v-select :options="options" v-model="unitLocatForm.uarea" :reduce="value => value.value" />&ndash;&gt;
                              <el-select v-model="unitLocatForm.uarea" clearable filterable placeholder="" size="medium" :popper-append-to-body="false"
                                         style="width: 100%;">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </div>-->
                          <input id="uarea" v-model="unitLocatForm.uarea" class="form-control" name="uarea"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 举报人姓名:</th>
                        <td class="formValue">
                          <input id="ureportName" v-model="unitLocatForm.ureportName" class="form-control"
                                 name="ureportName" style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style=""> 所在单位:</th>
                        <td class="formValue" colspan="3">
                          <input id="uunitLocat" v-model="unitLocatForm.uunitLocat" class="form-control"
                                 name="uunitLocat" style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 性别:</th>
                        <td class="formValue">

                          <!--												<select class="form-control" id="ureportSex" name="ureportSex" data-placeholder="请选择" v-model="unitLocatForm.ureportSex" style="width: 100%">-->
                          <!--													<option value="">请选择</option>-->
                          <!--													<option value="男">男</option>-->
                          <!--													<option value="女">女</option>-->
                          <!--												</select>-->
                          <el-select v-model="unitLocatForm.ureportSex" clearable placeholder="请选择" size="medium" :popper-append-to-body="false"
                                     style="width: 100%">
                            <el-option key="男" label="男" value="男"></el-option>
                            <el-option key="女" label="女" value="女"></el-option>
                          </el-select>
                        </td>

                      </tr>
                      <tr>
                        <th class="formTitle" style=""> 联系地址:</th>
                        <td class="formValue" colspan="3">
                          <input id="ucontactAddress" v-model="unitLocatForm.ucontactAddress" class="form-control"
                                 name="ucontactAddress" style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 职务:</th>
                        <td class="formValue">
                          <input id="ureportJob" v-model="unitLocatForm.ureportJob" class="form-control"
                                 name="ureportJob" style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>
                      <tr>

                        <th class="formTitle" style=""> 手机:</th>
                        <td class="formValue">
                          <input id="ucellphone" v-model="unitLocatForm.ucellphone" class="form-control" maxlength="11"
                                 name="ucellphone" oninput="value=value.replace(/[^\d]/g,'')" style="width: 100%"
                                 type="text" value=""/>
                        </td>

                        <th class="formTitle" style=""> 身份证号:</th>
                        <td class="formValue">
                          <input id="uidCard" v-model="unitLocatForm.uidCard" class="form-control" maxlength="18"
                                 name="uidCard" oninput="value=value.replace(/[^\d|xX]/g,'')" style="width: 100%"
                                 type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> 固话:</th>
                        <td class="formValue">
                          <input id="utelephone" v-model="unitLocatForm.utelephone" class="form-control" maxlength="13"
                                 name="utelephone" oninput="value=value.replace(/[^\d{1,}\-\d{1,}|\d{1,}]/g,'')"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>

                      <tr>
                        <th class="formTitle" style=""> 邮政编码:</th>
                        <td class="formValue">
                          <input id="upostcode" v-model="unitLocatForm.upostcode" class="form-control" maxlength="6"
                                 name="upostcode" oninput="value=value.replace(/[^\d]/g,'')" style="width: 100%"
                                 type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""> E-mail:</th>
                        <td class="formValue">
                          <input id="uemail" v-model="unitLocatForm.uemail" class="form-control" maxlength="20"
                                 name="uemail" style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle"></th>
                        <td class="formValue"></td>
                      </tr>

                      <tr>
                        <td colspan="6" style="width: 100%">
                          <div style="display: flex;align-items: center;">
                            <div class="vertical-rectangle"></div>
                            <span style="color: #BB1800;font-weight: bold;font-size: 16pt;">&nbsp;被举报单位信息</span>
                          </div>
                        </td>
                      </tr>
                      <tr>

                        <th class="formTitle" style="font-size: 13pt;font-family: Arial, Helvetica, sans-serif;"><font
                            color="red" face="宋体">*</font>所在地区:
                        </th>

                        <td class="formValue" colspan="5">
<!--                          <div>
                            <div style="width: 100%;">
                              &lt;!&ndash;													<v-select :options="options" v-model="unitLocatForm.uareaed" :reduce="value => value.value" />&ndash;&gt;
                              <el-select v-model="unitLocatForm.uareaed" clearable filterable placeholder="" :popper-append-to-body="false"
                                         size="medium" style="width: 100%;">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </div>
                          </div>-->
                          <input id="uareaed" v-model="unitLocatForm.uareaed" class="form-control" name="uareaed"
                                 style="width: 100%" type="text" value=""/>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>单位名称:</th>
                        <td class="formValue" colspan="3">
                          <input id="uunitLocated" v-model="unitLocatForm.uunitLocated" class="form-control"
                                 name="uunitLocated" style="width: 100%" type="text" value=""/>
                        </td>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>级别:</th>
                        <td class="formValue">
                          <!--											<select class="form-control chosen-select" codeId="JB01" data-placeholder="请选择" id="ureportedLevel" name="ureportedLevel" v-model="unitLocatForm.ureportedLevel" style="width: 100%" tabindex="2">-->
                          <!--												<option value="">请选择</option>-->
                          <!--												<option value="厅、局级">厅、局级</option>-->
                          <!--												<option value="副厅、副局级">副厅、副局级</option>-->
                          <!--												<option value="县、处级">县、处级</option>-->
                          <!--												<option value="副县、副处级">副县、副处级</option>-->
                          <!--												<option value="乡、科级">乡、科级</option>-->
                          <!--												<option value="副乡、副科级">副乡、副科级</option>-->
                          <!--												<option value="其他">其他</option>-->
                          <!--										  </select>-->
                          <el-select v-model="unitLocatForm.ureportedLevel" clearable placeholder="请选择" size="medium" :popper-append-to-body="false"
                                     style="width: 100%">
                            <el-option key="厅、局级" label="厅、局级" value="厅、局级"></el-option>
                            <el-option key="副厅、副局级" label="副厅、副局级" value="副厅、副局级"></el-option>
                            <el-option key="县、处级" label="县、处级" value="县、处级"></el-option>
                            <el-option key="副县、副处级" label="副县、副处级" value="副县、副处级"></el-option>
                            <el-option key="乡、科级" label="乡、科级" value="乡、科级"></el-option>
                            <el-option key="副乡、副科级" label="副乡、副科级" value="副乡、副科级"></el-option>
                            <el-option key="其他" label="其他" value="其他"></el-option>
                          </el-select>
                        </td>
                        <th class="formTitle"></th>
                        <td class="formValue"></td>
                      </tr>


                      <tr>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>主要问题:</th>
                        <td class="formValue" colspan="5">
                          <textarea id="umainProblems" v-model="unitLocatForm.umainProblems" class="form-control "
                                    name="umainProblems" rows="5"
                                    style="resize:none;height: 150px !important;width: 100%;" value=""></textarea>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style="">上传附件:</th>
                        <td class="formValue" colspan="5" style="border: 1px solid #ccc;border-radius: 3px;">
                          <el-upload
                              ref="upload"
                              :auto-upload="true"
                              :before-upload="beforeUpload"
                              :file-list="fileList"
                              :limit=1
                              :on-preview="handlePreview"
                              :on-remove="handleRemove"
                              :on-success="handleUploadSuccess"
                              accept=".zip"
                              action="/api/api/upload"
                              class="upload-demo">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>

                            <div slot="tip" class="el-upload__tip">只能上传zip压缩文件，且不超过10MB</div>
                          </el-upload>
                        </td>
                      </tr>
                      <tr>
                        <th class="formTitle" style=""><font color="red" face="宋体">*</font>
                          验证码:
                        </th>
                        <td class="formValue">
                          <input id="Txtidcode" v-model="code2" class="form-control" name="Txtidcode"
                                 placeholder="请输入验证码" style="height: 28px; width: 95%;" type="text"/>
                        </td>
                        <th class="formTitle">
                          <div class="login-code" style="float: left;" @click="refreshCode()">
                            <!--验证码组件-->
                            <s-identifyss :identifyCode="identifyCode"></s-identifyss>
                          </div>

                        </th>
                        <td class="formValue">
                          <a style="cursor: pointer;color: #1098EC;float: left;margin-top: 5px;" @click="refreshCode()">换个验证码？</a>
                        </td>
                        <th class="formTitle"></th>
                        <td class="formValue"></td>

                      </tr>
                      </TBODY>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <div style="width:85%;float:left;margin-bottom: 10px">
                <div style="margin-left: 137px">
                  <div style="float: left;margin-top: 5px;margin-left: 8px;font-size: 13pt;font-family: Arial, Helvetica, sans-serif;">验证码：</div>
                  <div style="float: left;"><input class="form-control" id="Txtidcode" name="Txtidcode" v-model="code2" placeholder="请输入验证码" type="text" style="height: 28px;" /></div>
                  <div class="login-code" style="float: left;" @click="refreshCode()">

                    <s-identifyss :identifyCode="identifyCode"></s-identifyss>
                  </div>
                  <a @click="refreshCode()" style="cursor: pointer;color: #1098EC;float: left;margin-top: 5px;">换个验证码？</a>
                </div>
              </div> -->

              <div class="btndiv" style="display: flex; justify-content: center; align-items: center;">
                <a style="cursor: pointer;" @click="resetUnitLocatForm()">
                  <div
                      style="width: 200px;height: 40px; background-color: #C5C5C5;display: flex;justify-content: center;align-items: center;">
                    <span style="color: #fff;font-size: large;">重写</span></div>
                </a> &nbsp;
                <a style="cursor: pointer;" @click="commitUnitLocatForm()">
                  <div
                      style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                    <span style="color: #fff;font-size: large;">提交</span></div>
                </a>
              </div>
            </div>
          </form>
        </div>

        <!-- 举报须知 -->
        <div v-show="isVisible4" id="page4" class="pageCss">
          <div align="center">
            <div style="width: 520px;height: 30px;">
              <h1 style="display: flex;align-items: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;">举报须知</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <div style="margin-left: 15px;margin-right: 15px;margin-top: 30px">
            <ol style="font-size: 15pt;">
              <li align="left;" style="margin-bottom:5px;margin-top: 10px">
                <span style=" font-size: 15pt;line-height: 40px;">本举报网站主要受理反映利津县各级领导班子和领导干部违反干部选拔任用工作政策法规选人用人，以及领导干部政治、思想、作风、廉洁自律等方面问题的举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span style="font-size: 15pt;line-height: 40px;">请认真填写举报表单中的各项目。填写“主要问题”一项时，要写清楚问题发生的时间、地点、涉及人员、情节、后果等，字数一般限定在800字。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span style="font-size: 15pt;line-height: 40px;">举报人应实事求是地反映问题。对利用举报捏造事实，进行诬告陷害的，依照有关规定严肃处理；构成犯罪的，移交司法机关处理。</span>
              </li>
              <li align="left" style="margin-bottom:1px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">提倡实名举报。进行实名举报时，请详细填写联系电话等项目。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span style="font-size: 15pt;line-height: 40px;">为保障举报人的合法权益，限制恶意重复举报和垃圾信件，提高网上举报的运行效率，举报人计算机每天最多只能提交5件举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
							<span style="font-size: 15pt;line-height: 40px;">网上举报只是反映问题的一种途径，还可通过信件或电话、短信等形式进行举报。<br/>
							通讯地址：东营市利津县利一路121号组宣党史综合楼308室，邮政编码：257400<br/>
							联系电话：0546-5612380<br/>
							短信举报号码：15154612380（仅接收短信）。<br/>
							</span>
              </li>
            </ol>
            <div align="center">
              <div style="width: 100%;height: 30px;">
                <h1 style="display: flex;align-items: center;justify-content: center;">
                  <div class="gradient-line"></div>
                  <span style="color: #BB1800;">其他举报方式</span>
                  <div class="gradient-line-right"></div>
                </h1>
              </div>
            </div>
            <ol style="font-size: 15pt;">
              <li align="left" style="margin-bottom:5px;margin-top: 10px;text-align: left;">
                <span style="font-size: 15pt;line-height: 40px;">如果您要反映违反党的纪律问题，请向<a
                    href="http://shandong.12388.gov.cn/dongying/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市纪委监委</a>相关部门进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映个人信访等问题，请向<a
                    href="http://dyxf.dongying.gov.cn/" target="_blank" style="text-decoration: none; color: blue;">东营市信访局</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;text-align: left;">
                <span style="font-size: 15pt;line-height: 40px;">如果您要反映涉法涉诉等问题，请向<a
                    href="http://www.dyjc.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市人民检察院</a>或<a
                    href="http://dyzy.sdcourt.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市中级人民法院</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映土地征用、房屋拆迁及房产纠纷等问题，请向<a
                    href="http://dyzrzy.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市自然资源和规划局</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映土地、山林、水利权属纠纷等问题，请向<a
                    href="http://dyzrzy.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市自然资源和规划局</a>或<a
                    href="http://dyny.dongying.gov.cn/"
                    target="_blank"
                    style="text-decoration: none; color: blue;">东营市农业农村局</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;text-align: left;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映劳动用工维权等问题，请向<a
                    href="http://dylss.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市人力资源和社会保障局</a>进行举报。</span>
              </li>
            </ol>

            <div align="center">
              <div style="width: 520px;height: 30px;">
                <h1 style="display: flex;align-items: center;">
                  <div class="gradient-line"></div>
                  <span style="color: #BB1800;">受理介绍</span>
                  <div class="gradient-line-right"></div>
                </h1>
              </div>
            </div>
<!--            <div style="margin-left: 15px;margin-right: 15px;margin-top: 30px">-->
              <ol style="font-size: 15pt;">
                <li align="left" style="margin-bottom:5px;margin-top: 10px">
                  <span style="font-size: 15pt;line-height: 40px;">本举报网站的受理部门是中共利津县委组织部。</span>
                </li>
                <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">中共利津县委组织部将本着“态度认真、办理公正、调查及时、处理严肃”的原则，慎重负责地处理网上举报件。</span>
                </li>
                <li align="left" style="margin-bottom:5px;">
                  <span style="font-size: 15pt;line-height: 40px;">对受理范围内的举报，根据被举报对象的职级和举报反映的问题，依据有关规定，由中共利津县委组织部办理或督促有关地方、部门（单位）组织人事部门及其他相关部门承办。其中，对群众反映的性质严重、内容具体、线索清楚的选人用人问题及其他主要问题，中共利津县委组织部进行立项督查，要求承办单位在规定时限内报告查核处理结果。</span>
                </li>
                <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">对经查问题属实的，依据有关规定，坚决纠正、严肃问责；严重违反规定、已构成违纪违法的，移交执纪执法机关处理。</span>
                </li>
                <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">为了保护举报人，严格执行保密制度，切实保护举报人的合法权益，对打击报复举报人的行为，严肃追究有关人员的责任。</span>
                </li>
              </ol>
<!--            </div>-->
          </div>
          <div class="btndiv" style="display: flex;justify-content: center;">
            <a style="cursor: pointer;" @click="tabSwitch('tabs','page',1)">
              <div
                  style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                <span style="color: #fff;font-size: large;">我要举报</span></div>
            </a>
          </div>
        </div>

        <!-- 受理介绍 -->
        <div v-show="isVisible3" id="page3" class="pageCss">
          <div align="center">
            <div style="width: 520px;height: 30px;">
              <h1 style="display: flex;align-items: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;">受理介绍</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <div style="margin-left: 15px;margin-right: 15px;margin-top: 30px">
            <ol style="font-size: 15pt;">
              <li align="left" style="margin-bottom:5px;margin-top: 10px">
                <span style="font-size: 15pt;line-height: 40px;">本举报网站的受理部门是中共利津县委组织部。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">中共利津县委组织部将本着“态度认真、办理公正、调查及时、处理严肃”的原则，慎重负责地处理网上举报件。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span style="font-size: 15pt;line-height: 40px;">对受理范围内的举报，根据被举报对象的职级和举报反映的问题，依据有关规定，由中共利津县委组织部办理或督促有关地方、部门（单位）组织人事部门及其他相关部门承办。其中，对群众反映的性质严重、内容具体、线索清楚的选人用人问题及其他主要问题，中共利津县委组织部进行立项督查，要求承办单位在规定时限内报告查核处理结果。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">对经查问题属实的，依据有关规定，坚决纠正、严肃问责；严重违反规定、已构成违纪违法的，移交执纪执法机关处理。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">为了保护举报人，严格执行保密制度，切实保护举报人的合法权益，对打击报复举报人的行为，严肃追究有关人员的责任。</span>
              </li>
            </ol>
          </div>
          <div class="btndiv" style="display: flex;justify-content: center;">
            <a style="cursor: pointer;" @click="tabSwitch('tabs','page',1)">
              <div
                  style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                <span style="color: #fff;font-size: large;">我要举报</span></div>
            </a>
          </div>
        </div>

        <!--法规制度  -->
        <!-- <div class="pageCss" id="page4" v-show="isVisible4">
          <div align="center">
                    <div style="width: 520px;height: 30px;">
                      <h1 style="display: flex;align-items: center;"><div class="gradient-line"></div><span style="color: #BB1800;">法规制度</span><div class="gradient-line-right"></div></h1>
                    </div>
                  </div>
                  <div style="margin-left: 15px;margin-right: 15px;margin-top: 10px">
            <ol style="font-size: 15pt;" v-show="regulationsShow">
              <li v-for="item in regulations" :key="item.notice_title" style="margin-bottom:5px;"><a @click="regulationsClick(item.notice_id)" style="cursor: pointer;font-size: 15pt;">{{ item.notice_title }}</a></li>

            </ol>
          </div>
          <div v-for="item in regulations" :key="item.notice_title" v-show="item.notice_id==notice_select" id="rule" style="background-color: white">
    <div v-html='item.notice_content' style="word-wrap: break-word;"></div>
          </div>
          <div class="btndiv" style="display: flex;justify-content: center;">
              <a @click="tabSwitch('tabs','page',1)" style="cursor: pointer;"><div style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;"><span style="color: #fff;font-size: large;">我要举报</span></div> </a>
            </div>
        </div> -->

        <!--联系方式  -->
        <div v-show="isVisible5" id="page5" class="pageCss">
          <div align="center">
            <div style="width: 600px;height: 30px;">
              <h1 style="display: flex;align-items: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;">市县区联系方式</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <div style="margin-left: 15px;margin-right: 15px;margin-top: 30px;">
<!--            <p style="padding: 10px;">&nbsp;&nbsp;
              <span style="font-size:16pt !important;font-weight:bold;line-height: 40px;">东营市委组织部</span><br/>
              <span style="font-size: 15pt;line-height: 40px; font-family: 宋体, Arial, Helvetica, sans-serif;">
						举报电话：0546-12380 <br/>
						短信举报：18354612380(仅接收短信)<br/>
						通信地址：东营市东城府前大街77号中共东营市委组织部干部监督科<br/>
						邮政编码：257091
					</span>
            </p>-->

            <p style="padding: 10px">&nbsp;&nbsp;
              <span style="font-size:16pt !important;font-weight:bold;line-height: 40px;">东营区委组织部</span><br/>
              <span style="font-size: 15pt;line-height: 40px;">
						举报电话：0546-8312380<br/>
						举报网站：<a href="http://www.dyq12380.gov.cn" target="_blank">www.dyq12380.gov.cn</a><br/>
						短信举报：15266012380(仅接收短信)<br/>
						通信地址：东营市东营区宁阳路89号0号楼917房间 <br/>
						邮政编码：257000
					</span>
            </p>

            <p style="padding: 10px">&nbsp;&nbsp;
              <span style="font-size:16pt !important;font-weight:bold;line-height: 40px;">河口区委组织部</span><br/>
              <span style="font-size: 15pt;line-height: 40px;">
						举报电话：0546-3612380<br/>
						举报网站：<a href="http://www.hk12380.gov.cn" target="_blank">www.hk12380.gov.cn</a><br/>
						短信举报：13668612380(仅接收短信)<br/>
						通信地址：河口区黄河路93号党政办公大楼824室<br/>
						邮政编码：257200
					</span>
            </p>
            <p style="padding: 10px">&nbsp;&nbsp;
              <span style="font-size:16pt !important;font-weight:bold;line-height: 40px;">垦利区委组织部</span><br/>
              <span style="font-size: 15pt;line-height: 40px;">
						举报电话：0546-2521380<br/>
						举报网站：<a href="http://www.kl12380.gov.cn" target="_blank">www.kl12380.gov.cn</a><br/>
						短信举报：18454612380(仅接收短信)<br/>
						通信地址：东营市垦利区胜兴路16号党政办公楼805房间<br/> 邮政编码：257500
					</span>
            </p>
            <p style="padding: 10px">&nbsp;&nbsp;
              <span style="font-size:16pt !important;font-weight:bold;line-height: 40px;">广饶县委组织部</span><br/>
              <span style="font-size: 15pt;line-height: 40px;">
							举报电话：0546-6512380<br/>
							举报网站：<a href="http://www.gr12380.gov.cn" target="_blank">www.gr12380.gov.cn</a><br/>
							短信举报：15564612380(仅接收短信)<br/>
							通信地址：广饶县乐安大街乐安大厦781房间<br/> 邮政编码：257300
					</span>
            </p>


          </div>
          <div class="btndiv" style="display: flex;justify-content: center;">
            <a style="cursor: pointer;" @click="tabSwitch('tabs','page',1)">
              <div
                  style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                <span style="color: #fff;font-size: large;">我要举报</span></div>
            </a>
          </div>
        </div>

        <!-- 其他举报方式 -->
        <div v-show="isVisible8" id="page8" class="pageCss">
          <div align="center">
            <div style="width: 580px;height: 30px;">
              <h1 style="display: flex;align-items: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;">其他举报方式</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <div style="margin-left: 15px;margin-right: 15px;margin-top: 30px">
            <ol style="font-size: 15pt;">
              <li align="left" style="margin-bottom:5px;margin-top: 10px">
                <span style="font-size: 15pt;line-height: 40px;">如果您要反映违反党的纪律问题，请向<a
                    href="http://shandong.12388.gov.cn/dongying/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市纪委监委</a>相关部门进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映个人信访等问题，请向<a
                    href="http://dyxf.dongying.gov.cn/" target="_blank" style="text-decoration: none; color: blue;">东营市信访局</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span style="font-size: 15pt;line-height: 40px;">如果您要反映涉法涉诉等问题，请向<a
                    href="http://www.dyjc.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市人民检察院</a>或<a
                    href="http://dyzy.sdcourt.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市中级人民法院</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映土地征用、房屋拆迁及房产纠纷等问题，请向<a
                    href="http://dyzrzy.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市自然资源和规划局</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映土地、山林、水利权属纠纷等问题，请向<a
                    href="http://dyzrzy.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市自然资源和规划局</a>或<a
                    href="http://dyny.dongying.gov.cn/"
                    target="_blank"
                    style="text-decoration: none; color: blue;">东营市农业农村局</a>进行举报。</span>
              </li>
              <li align="left" style="margin-bottom:5px;">
                <span
                    style="font-size: 15pt;line-height: 40px;">如果您要反映劳动用工维权等问题，请向<a
                    href="http://dylss.dongying.gov.cn/" target="_blank"
                    style="text-decoration: none; color: blue;">东营市人力资源和社会保障局</a>进行举报。</span>
              </li>
            </ol>
          </div>
          <div class="btndiv" style="display: flex;justify-content: center;">
            <a style="cursor: pointer;" @click="tabSwitch('tabs','page',1)">
              <div
                  style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                <span style="color: #fff;font-size: large;">我要举报</span></div>
            </a>
          </div>
        </div>

        <!--意见建议  -->
        <div v-show="isVisible6" id="page6" class="pageCss">
          <div align="center">
            <div style="width: 520px;height: 30px;">
              <h1 style="display: flex;align-items: center;">
                <div class="gradient-line"></div>
                <span style="color: #BB1800;">意见建议</span>
                <div class="gradient-line-right"></div>
              </h1>
            </div>
          </div>
          <div style="margin-top: 30px;margin-left: 15px;font-size: 15pt;">
            <span>欢迎对网上举报工作及网站建设提出意见建议：</span></div>
          <div style="margin-left: 15px;margin-right: 15px;margin-top: 10px;border: 1px solid #bb1800;">
            <div style="width: 850px;margin: 0 auto;margin-top: 20px;margin-bottom: 20px;">
              <form id="opinionForm" action="" class="form-horizontal m-t" method="post">
                <table class="form" style="width: 100%;">
                  <TBODY>
                  <tr>
                    <th class="formTitle" style="font-size: 13pt; font-family: Arial, Helvetica, sans-serif;"><font
                        color="red" face="宋体">*</font>意见建议:
                    </th>
                    <td class="formValue" colspan="3">
                      <textarea id="suggestions" v-model="opinionForm.suggestions" class="form-control " cols="75"
                                name="suggestions" rows="7" style="resize:none;height: 150px !important;width: 100%;"
                                value=""></textarea>
                    </td>
                  </tr>
                  <tr>
                    <th class="formTitle" style="font-size: 13pt; font-family: Arial, Helvetica, sans-serif;"> 姓名:
                    </th>
                    <td class="formValue">
                      <input id="name" v-model="opinionForm.name" class="form-control" name="name" type="text"
                             value=""/>
                    </td>
                    <th class="formTitle" style="font-size: 13pt; font-family: Arial, Helvetica, sans-serif;">
                      联系方式:
                    </th>
                    <td class="formValue">
                      <input id="cellphone" v-model="opinionForm.cellphone" class="form-control" name="cellphone"
                             style="width: 100%;" type="text" value=""/>
                    </td>
                  </tr>
                  <tr>
                    <th class="formTitle" style="font-size: 13pt; font-family: Arial, Helvetica, sans-serif;"><font color="red" face="宋体">*</font>验证码:
                    </th>
                    <td class="formValue" colspan="2">
                      <div style="float: left;"><input id="Txtidcode" v-model="code1" class="form-control"
                                                       name="Txtidcode" placeholder="请输入验证码" style="height: 28px;"
                                                       type="text"/></div>
                      <div class="login-code" style="float: left; margin-top: 10px;" @click="refreshCode()">
                        <!--验证码组件-->
                        <s-identifys :identifyCode="identifyCode"></s-identifys>
                      </div>
                      <a style="cursor: pointer;color: #1098EC;float: left;" @click="refreshCode()">换个验证码？</a>
                    </td>
                    <td class="formValue">
                      <div class="btndiv" style="display: flex; justify-content: left; align-items: center;margin: 0px">
                        <a style="cursor: pointer;width: 100%;" @click="commitOpinion()">
                          <div
                              style="height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                            <span style="color: #fff;font-size: large;">提交</span></div>
                        </a>
                      </div>
                    </td>
                  </tr>

                  </TBODY>
                </table>
              </form>
            </div>
          </div>
          <div class="btndiv" style="display: flex;justify-content: center;">
            <a style="cursor: pointer;" @click="tabSwitch('tabs','page',1)">
              <div
                  style="width: 200px;height: 40px;background-color: #BB1800;display: flex;justify-content: center;align-items: center;">
                <span style="color: #fff;font-size: large;">我要举报</span></div>
            </a>
          </div>
        </div>


      </div>
      <div style="top: 90vh; width: 100%;height: 50px;text-align: center;vertical-align: middle; line-height: 50px;">
        <a href="https://beian.miit.gov.cn" style="color: #BB1800;text-decoration: none;font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
			font-size: 14px;">备案号：鲁ICP备10012882号-2</a>
      </div>

    </div>

    <!-- <button @click="showPopup">显示弹窗</button> -->

  </div>


</template>
<script src="element-ui/lib/theme-chalk/index.js">
</script>
<script src="element-ui/lib/alert.js"></script>
<script src="vue/dist/vue.js"></script>
<script>
import axios from 'axios';
import SIdentify from '../components/sidentify'
import SIdentifys from '../components/sidentifys'
import SIdentifyss from '../components/sidentifyss'
import vSelect from 'vue-select'
import Popup from '../components/Popup.vue';
import ElementUI from 'element-ui'
import _ from 'lodash';


export default {
  name: 'IndexPage',
  components: {SIdentify, SIdentifys, SIdentifyss, vSelect, Popup, ElementUI},
  data() {
    return {
      uploadData: '',
      uploadMax: true,
      fileList: [],
      popupVisible: false,
      popupContent: '这是一个弹窗',
      imglogo1: require('@/assets/logo1.png'),
      imglogo2: require('@/assets/logo21.png'),
      imglogo3: require('@/assets/logo31.png'),
      imglogo4: require('@/assets/logo41.png'),
      imglogo5: require('@/assets/logo51.png'),
      imglogo6: require('@/assets/logo61.png'),
      imglogo8: require('@/assets/logo81.png'),
      isVisible1: true,
      isVisible2: false,
      isVisible3: false,
      isVisible4: false,
      isVisible5: false,
      isVisible6: false,
      isVisible7: false,
      isVisible8: false,
      regulationsShow: true,
      notice_select: null,
      isAgreeChecked: '',
      flag: 0,
      active: 1,
      regulations: [],
      psersonForm: {
        area: '',
        areaed: '',
        reportName: '',
        unitLocat: '',
        reportSex: '',
        contactAddress: '',
        reportJob: '',
        cellphone: '',
        idCard: '',
        telephone: '',
        postcode: '',
        email: '',
        reportedName: '',
        reportedSex: '',
        politicalOutlook: '',
        reportedLevel: '',
        unitLocated: '',
        reportedJob: '',
        mainProblems: '',
        filePath: '',
      },
      originalForm: null,

      unitLocatForm: {
        uarea: '',
        uareaed: '',
        ureportName: '',
        uunitLocat: '',
        ureportSex: '',
        ucontactAddress: '',
        ureportJob: '',
        ucellphone: '',
        uidCard: '',
        utelephone: '',
        upostcode: '',
        uemail: '',
        ureportedName: '',
        ureportedSex: '',
        upoliticalOutlook: '',
        ureportedLevel: '',
        uunitLocated: '',
        ureportedJob: '',
        umainProblems: '',
        filePath: '',
      },
      originalUnitLocatForm: null,

      opinionForm: {
        suggestions: '',
        name: '',
        cellphone: ''
      },
      originalOpinionForm: null,

      identifyCodes: "1234567890",
      identifyCode: "",
      code: "", code1: "", code2: "",//text框输入的验证码

      selected: null,
      options: [
        {label: '东营市利津县利津街道办事处', value: '东营市利津县利津街道办事处'},
        {label: '东营市利津县凤凰城街道办事处', value: '东营市利津县凤凰城街道办事处'},
        {label: '东营市利津县明集乡', value: '东营市利津县明集乡'},
        {label: '东营市利津县刁口乡', value: '东营市利津县刁口乡'},
        {label: '东营市利津县陈庄镇', value: '东营市利津县陈庄镇'},
        {label: '东营市利津县北宋镇', value: '东营市利津县北宋镇'},
        {label: '东营市利津县盐窝镇', value: '东营市利津县盐窝镇'},
        {label: '东营市利津县汀罗镇', value: '东营市利津县汀罗镇'}
        // ...更多选项
      ]
    };
  },

  computed: {
    windowHeight() {
      return window.innerHeight;
    }
  },

  created() {
    //document.title = '欢迎来到中共东营市委组织部12380举报网站';
    // 在组件创建时保存一个表单的原始副本
    this.originalForm = Object.assign({}, this.psersonForm);
    this.originalUnitLocatForm = Object.assign({}, this.unitLocatForm);
    this.originalOpinionForm = Object.assign({}, this.opinionForm);
    this.refreshCode();
    //this.fetchData();
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    showPopup(active) {
      this.active = active;
      this.popupVisible = true;
      this.$refs.child.initStart(10);
    },
    closePopup() {
      this.popupVisible = false;
      //this.tabSwitch('tabs','page',this.active);
    },
    fetchData() {
      axios.get('/api/api/getRegulation')
          .then(response => {
            this.regulations = response.data; // 假设响应数据是数组格式
            //console.log(this.regulations);
          })
          .catch(error => {
            console.error('There was an error!', error);
          });
    },
    resetForm() {
      // 重置表单，将数据恢复到原始状态
      this.psersonForm = Object.assign({}, this.originalForm);
      this.code = "";
      this.fileList = [];
      this.uploadData = ''
    },
    commit() {
      // this.$refs.upload.submit();
      // if (!this.uploadMax) {
      //   return;
      // }
      this.psersonForm.filePath = this.uploadData;
      if (this.code == "") {
        // alert("请输入验证码！");
        this.$alert('请输入验证码！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.identifyCode != this.code) {
        this.code = '';
        this.refreshCode();
        // alert("请输入正确的验证码！")
        this.$alert('请输入正确的验证码！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.psersonForm.areaed == '') {
        // alert("请输入被举报人所在地区！");
        this.$alert('请输入被举报人所在地区！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.psersonForm.reportedName == '') {
        // alert("请输入被举报人！");
        this.$alert('请输入被举报人！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.psersonForm.reportedLevel == '') {
        // alert("请输入被举报人级别！");
        this.$alert('请输入被举报人级别！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.psersonForm.mainProblems == '') {
        // alert("请输入主要问题！");
        this.$alert('请输入主要问题！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      const tabSwitch = this.tabSwitch;
      const that = this;


      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/api/api/addPsersonForm', JSON.stringify(this.psersonForm), {
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(function (response) {
              //console.log(response.data);
              if (response.data == 1) {
                // alert("提交成功！");
                that.$alert('提交成功！', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    tabSwitch('tabs', 'page', 1);
                  }
                });

              } else if (response.data == 2) {
                // alert("提交失败，已达到今日最大提交次数！")
                that.$alert('提交失败，已达到今日最大提交次数！', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              } else {
                // alert("提交失败！")
                that.$alert('提交失败！', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });


    },
    //单位
    resetUnitLocatForm() {
      // 重置表单，将数据恢复到原始状态
      this.unitLocatForm = Object.assign({}, this.originalUnitLocatForm);
      this.code2 = "";
      this.fileList = [];
      this.uploadData = ''
    },
    commitUnitLocatForm() {
      this.unitLocatForm.filePath = this.uploadData;
      if (this.code2 == "") {
        // alert("请输入验证码！");
        this.$alert('请输入验证码！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.identifyCode != this.code2) {
        this.code2 = '';
        this.refreshCode();
        // alert("请输入正确的验证码！")
        this.$alert('请输入正确的验证码！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.unitLocatForm.uareaed == '') {
        // alert("请输入被举报单位所在地区！");
        this.$alert('请输入被举报单位所在地区！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.unitLocatForm.uunitLocated == '') {
        // alert("请输入被举报单位名称！");
        this.$alert('请输入被举报单位名称！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.unitLocatForm.ureportedLevel == '') {
        // alert("请输入被举报单位级别！");
        this.$alert('请输入被举报单位级别！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.unitLocatForm.umainProblems == '') {
        // alert("请输入主要问题！");
        this.$alert('请输入主要问题！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      const tabSwitch = this.tabSwitch;
      const that = this;

      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/api/api/addUnitLocatForm', JSON.stringify(this.unitLocatForm), {
          headers: {
            'Content-Type': 'application/json'
          }
        })
            .then(function (response) {
              //console.log(response.data);
              if (response.data == 1) {
                // alert("提交成功！");
                that.$alert('提交成功！', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    tabSwitch('tabs', 'page', 1);
                  }
                });

              } else if (response.data == 2) {
                // alert("提交失败，已达到今日最大提交次数！")
                that.$alert('提交失败，已达到今日最大提交次数！', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              } else {
                // alert("提交失败！")
                that.$alert('提交失败！', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });


    },

    resetOpinionForm() {
      // 重置表单，将数据恢复到原始状态
      this.opinionForm = Object.assign({}, this.originalOpinionForm);
      this.code1 = "";
    },

    commitOpinion() {
      if (this.code1 == "") {
        this.$alert('请输入验证码！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.identifyCode != this.code1) {
        this.code1 = '';
        this.refreshCode();
        // alert("请输入正确的验证码！")
        this.$alert('请输入正确的验证码！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.opinionForm.suggestions == "") {
        // alert("请输入意见建议！");
        this.$alert('请输入意见建议！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
//console.log("意见建议:"+this.opinionForm.suggestions);
      const tabSwitch = this.tabSwitch;
      const that = this


      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/api/api/addOpinionForm', JSON.stringify(this.opinionForm), {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {

          //console.log(response.data);
          if (response.data == 1) {
            that.$alert('提交成功！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                tabSwitch('tabs', 'page', 1);
              }
            });

          } else if (response.data == 2) {
            that.$alert('提交失败，已达到今日最大提交次数！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                //tabSwitch('tabs','page',1);
              }
            });
          } else {
            that.$alert('提交失败！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                //tabSwitch('tabs','page',1);
              }
            });
          }
        })
            .catch(function (error) {
              console.log(error);
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });


    },
    goReport() {
      this.popupVisible = false;
      this.tabSwitch('tabs', 'page', this.active)
    },
    tabSwitch(tabname, content_prefix, active) {
      //console.log(tabname,content_prefix,active)
      for (var i = 1; i <= 8; i++) {
        if (this.$refs.tabs1) {
          this.$refs.tabs1.classList.remove('active');
        }
        this.$refs.tabs1.classList.add('active');
      }

      //举报须知
      if (active == 1) {

        this.isVisible1 = true;
        this.isVisible2 = false;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.isVisible7 = false;
        this.isVisible8 = false;
        this.$refs.li1.classList.add('selected');
        // this.$refs.li2.classList.remove('selected');
        // this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 1;
        this.imglogo1 = require('@/assets/logo1.png');
        // this.imglogo2= require('@/assets/logo21.png');
        // this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo81.png');
        this.isAgreeChecked = '';
      }
      if (active == 2) {
        // if (!this.isAgreeChecked) {
        // 	alert("请阅读举报须知说明，然后选中‘我同意上述条款’!");
        // 	return;
        // }

        this.isVisible1 = false;
        this.isVisible2 = true;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.isVisible7 = false;
        this.isVisible8 = false;
        this.$refs.li1.classList.add('selected');
        // this.$refs.li2.classList.add('selected');
        // this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 1;
        this.imglogo1 = require('@/assets/logo1.png');
        // this.imglogo2= require('@/assets/logo2.png');
        // this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo81.png');
      }

      if (active == 7) {
        // if (!this.isAgreeChecked) {
        // 	alert("请阅读举报须知说明，然后选中‘我同意上述条款’!");
        // 	return;
        // }

        this.isVisible1 = false;
        this.isVisible2 = false;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.isVisible7 = true;
        this.isVisible8 = false;
        this.$refs.li1.classList.add('selected');
        // this.$refs.li2.classList.add('selected');
        // this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 1;
        this.imglogo1 = require('@/assets/logo1.png');
        // this.imglogo2= require('@/assets/logo2.png');
        // this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo81.png');
      }

      if (active == 3) {

        this.isVisible1 = false;
        this.isVisible2 = false;
        this.isVisible3 = true;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.isVisible7 = false;
        this.isVisible8 = false;
        this.$refs.li1.classList.remove('selected');
// this.$refs.li2.classList.remove('selected');
//         this.$refs.li3.classList.add('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 3;
        this.imglogo1 = require('@/assets/logo11.png');
// this.imglogo2= require('@/assets/logo21.png');
//         this.imglogo3 = require('@/assets/logo3.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo81.png');
      }
      if (active == 4) {

        this.isVisible1 = false;
        this.isVisible2 = false;
        this.isVisible3 = false;
        this.isVisible4 = true;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.isVisible7 = false;
        this.isVisible8 = false;
        this.$refs.li1.classList.remove('selected');
// this.$refs.li2.classList.remove('selected');
//         this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.add('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 4;
        this.imglogo1 = require('@/assets/logo11.png');
// this.imglogo2= require('@/assets/logo21.png');
//         this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo4.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo81.png');
        this.regulationsShow = true;
        this.notice_select = null;
      }
      if (active == 5) {

        this.isVisible1 = false;
        this.isVisible2 = false;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = true;
        this.isVisible6 = false;
        this.isVisible7 = false;
        this.isVisible8 = false;
        this.$refs.li1.classList.remove('selected');
// this.$refs.li2.classList.remove('selected');
//         this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.add('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 5;
        this.imglogo1 = require('@/assets/logo11.png');
// this.imglogo2= require('@/assets/logo21.png');
//         this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo5.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo81.png');
      }
      if (active == 6) {

        this.isVisible1 = false;
        this.isVisible2 = false;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = true;
        this.isVisible7 = false;
        this.isVisible8 = false;
        this.$refs.li1.classList.remove('selected');
// this.$refs.li2.classList.remove('selected');
//         this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.add('selected');
        this.$refs.li8.classList.remove('selected');
        this.active = 6;
        this.imglogo1 = require('@/assets/logo11.png');
// this.imglogo2= require('@/assets/logo21.png');
//         this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo6.png');
        this.imglogo8 = require('@/assets/logo81.png');
      }
      if (active == 8) {

        this.isVisible1 = false;
        this.isVisible2 = false;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.isVisible7 = false;
        this.isVisible8 = true;
        this.$refs.li1.classList.remove('selected');
// this.$refs.li2.classList.remove('selected');
//         this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
        this.$refs.li8.classList.add('selected');
        this.active = 8;
        this.imglogo1 = require('@/assets/logo11.png');
// this.imglogo2= require('@/assets/logo21.png');
//         this.imglogo3 = require('@/assets/logo31.png');
        this.imglogo4 = require('@/assets/logo41.png');
        // this.imglogo5 = require('@/assets/logo51.png');
        this.imglogo6 = require('@/assets/logo61.png');
        this.imglogo8 = require('@/assets/logo8.png');

        this.regulationsShow = true;
        this.notice_select = null;
      }

      this.refeshForm();
    },

    reportPersonal() {
      //console.log(this.isAgreeChecked)
      if (!this.isAgreeChecked) {
        alert("请阅读举报须知说明，然后选中‘我同意上述条款’!")
      } else {
        this.isVisible1 = false;
        this.isVisible2 = true;
        this.isVisible3 = false;
        this.isVisible4 = false;
        this.isVisible5 = false;
        this.isVisible6 = false;
        this.$refs.li1.classList.add('selected');
        // this.$refs.li2.classList.add('selected');
        // this.$refs.li3.classList.remove('selected');
        this.$refs.li4.classList.remove('selected');
        // this.$refs.li5.classList.remove('selected');
        this.$refs.li6.classList.remove('selected');
      }
    },

    changeActive(flag) {

      if (flag == 1) {
        this.imglogo1 = require('@/assets/logo1.png');
      }
      if (flag == 2) {
        this.imglogo2 = require('@/assets/logo2.png');
      }
      if (flag == 3) {
        this.imglogo3 = require('@/assets/logo3.png');
      }
      if (flag == 4) {
        this.imglogo4 = require('@/assets/logo4.png');
      }
      if (flag == 5) {
        this.imglogo5 = require('@/assets/logo5.png');
      }
      if (flag == 6) {
        this.imglogo6 = require('@/assets/logo6.png');
      }
      if (flag == 8) {
        this.imglogo8 = require('@/assets/logo8.png');
      }

    },
    removeActive(flag) {
      if (flag == 1 && this.active != 1) {
        this.imglogo1 = require('@/assets/logo11.png');
      }
      if (flag == 2 && this.active != 2) {
        this.imglogo2 = require('@/assets/logo21.png');
      }
      if (flag == 3 && this.active != 3) {
        this.imglogo3 = require('@/assets/logo31.png');
      }
      if (flag == 4 && this.active != 4) {
        this.imglogo4 = require('@/assets/logo41.png');
      }
      if (flag == 5 && this.active != 5) {
        this.imglogo5 = require('@/assets/logo51.png');
      }
      if (flag == 6 && this.active != 6) {
        this.imglogo6 = require('@/assets/logo61.png');
      }
      if (flag == 8 && this.active != 8) {
        this.imglogo8 = require('@/assets/logo81.png');
      }
    },
    regulationsClick(notice_id) {
      this.regulationsShow = false;
      this.notice_select = notice_id;

    },

    reportUnit() {
      // if (!this.isAgreeChecked) {
      // }
    },

    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
            ];
      }
      //console.log(this.identifyCode);
    },
    refeshForm() {
      this.resetOpinionForm();
      this.resetUnitLocatForm();
      this.resetForm();
      this.refreshCode();
      this.fileList = [];
      this.uploadData = ''

    },


    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.uploadData = '';
    },
    handlePreview(file) {
      //console.log(file);
    },
    beforeUpload(file) {
      const fileName = file.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      if(fileType !== '.zip'){
        this.$message.error('请上传zip类型文件！');
        return false;
      }


      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.uploadMax = false;
        this.$message.error('上传的文件大小不能超过 10MB!');
      }

      return isLt10M;
    },
    handleUploadSuccess(response) {
      // 上传成功后，把返回的数据保存到uploadData中
      this.uploadData = response;
      //console.log(response);
    },


  }


};

</script>

<style>
@import 'vue-select/dist/vue-select.css';
@import 'element-ui/lib/theme-chalk/index.css';

input, select, textarea {
  border: 1px solid #ccc;
  border-radius: 3px;
}

.index {
  min-width: 1400px;
}

#top {
  background: url("../assets/image.png");
  background-size: cover;
  /* width:1897px; */
  width: 100%;
  /* min-width: 1200px; */
  height: 400px;
  margin: 0px auto;
  padding: 0px;
}

#lj {
  background: url("../assets/top_bg_lj.png");
}

#header {
  width: 80%;
  /* min-width: 1000px; */
  height: 58px;
  background-color: #ffffff;
  padding-left: 0px;
  padding-right: 0px;
  margin: auto;
  margin-top: -30px;
  display: flex;
  justify-content: center;
}

#header_box {
  width: 100%;
  height: 58px;
  margin: 0 auto;
  margin-top: -30px;
  display: flex;
  justify-content: center;
  padding: 20px 50px 20px 50px;
}

#navigation {
  display: flex;
  list-style: none;
  width: 100%;
  /* padding: 0; */
  /* margin-left: 40px; */
  /* margin-top: 15px; */
  padding-inline-start: 0px;
  justify-content: space-between;
  padding-top: 30px;
  padding-left: 0px;
}

#navigation li {
  position: relative;
  float: left;
  height: 58px;
  width: 25%;
  margin: 5px;
}

#navigation li div {
  /* color: #b29eba; */
  color: #BB1800;
  /* display: block; */
  font-family: "Capriola-Regular";
  font-size: 14pt;
  line-height: 58px;
  padding: 0;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  position: relative;
  border: 1px solid #f03535;
}

.top_tab_style {
  display: flex;
  justify-content: center;
  align-items: center;
}

ol, ul {
  margin-top: 0;
  margin-bottom: 10px;
}

.btndiv {
  width: 100%;
  clear: both;
  margin: 30px auto;
  text-align: center;
}

.btndiv_ty {
  width: 100%;
  clear: both;
  margin: 30px auto;
  text-align: left;
}

.mbmContent {
  width: 76%;
  line-height: 25px;
  font-family: 宋体, Arial, Helvetica, sans-serif;
  font-size: 14px;
  clear: both;
  margin: 0px auto;
}

#navigation li div:hover, #navigation li.selected div {
  background-color: #BB1800;
  color: #fff;
  height: 58px;
  border-left: 1px solid #BB1800;
  border-right: 1px solid #BB1800;
}

.dotted-line {
  border-top: 1px dashed #BB1800; /* 虚线颜色和宽度 */
  width: 100%; /* 虚线的长度 */
  margin: 30px 0; /* 上下外边距，可根据需要调整 */
  /* margin-top: 10px; */
}

.gradient-line {
  width: 200px; /* 横线的宽度 */
  height: 2px; /* 横线的高度 */
  background: linear-gradient(to right, #fff, #BB1800); /* 渐变效果 */
}

.gradient-line-right {
  width: 200px; /* 横线的宽度 */
  height: 2px; /* 横线的高度 */
  background: linear-gradient(to right, #BB1800, #fff); /* 渐变效果 */
}

.vertical-rectangle {
  width: 8px; /* 设置元素的宽度 */
  height: 15px; /* 设置元素的高度 */
  background-color: #BB1800; /* 设置背景颜色 */
}

.form .formTitle {
  font-size: 13pt;
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
  left: 0px;
  text-align: right;
  white-space: nowrap;
  font-weight: normal;
  width: 90px;
  padding-right: 10px;
}

select {
  height: 32px;
  font-size: 12pt;
}

input {
  height: 28px;
  font-size: 12pt;
}

textarea {
  font-size: 12pt;
  font-family: Arial, Helvetica, sans-serif;
}

input:focus, select:focus, textarea:focus {
  outline: none;
}

/*验证码样式*/
.code {
  width: 124px;
  height: 31px;
  border: 1px solid rgba(186, 186, 186, 1);
}

.login-code {
  cursor: pointer;
}

.ql-align-center {
  text-align: center;
}

p {
  white-space: pre-wrap;
  word-break: break-word;
}

a:hover {
  color: #ff0000; /* 鼠标悬浮时文字颜色变为红色 */
}

body {
  margin: 0px
}

tr {
  line-height: 45px;
}

.upload-demo {
  margin-left: 10px;
}
.el-select-dropdown {
  position: absolute !important;
  left: 0px !important;
  top: 100% !important;
  border: 1px solid #010f13;
}
</style>
